"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASKET_STATUS_ERRORS = exports.GET_BASKET_POLLING_INTERVAL = exports.DEFAULT_MAX_BET_EXPRESS_COEF = exports.endedProbabilityStatus = exports.pendingProbabilityStatus = exports.activeProbabilityStatus = exports.endedEventStatus = exports.pendingEventStatus = exports.activeEventStatus = exports.endedOutcomeStatus = exports.pendingOutcomeStatus = exports.activeOutcomeStatus = exports.WEB_BOTTOM_ERRORS = exports.MOBILE_BOTTOM_ERRORS = exports.ERROR_LIST_WHEN_MAKE_RE_REQUEST_BASKET = exports.ALL_BASKET_ERROR_MESSAGES = exports.EAllBasketErrors = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
var EAllBasketErrors;
(function (EAllBasketErrors) {
    EAllBasketErrors["BETS_HAVE_DEPENDENT_EVENTS"] = "BETS_HAVE_DEPENDENT_EVENTS";
    EAllBasketErrors["BETS_OUTCOMES_INEQUALITY"] = "BETS_OUTCOMES_INEQUALITY";
    EAllBasketErrors["BETS_INSUFFICIENT_BALANCE"] = "BETS_INSUFFICIENT_BALANCE";
    EAllBasketErrors["BETS_INSUFFICIENT_BONUS"] = "BETS_INSUFFICIENT_BONUS";
    EAllBasketErrors["BETS_PAY_MAX_EXCEEDED"] = "BETS_PAY_MAX_EXCEEDED";
    EAllBasketErrors["EXPRESS_LENGTH"] = "EXPRESS_LENGTH";
    EAllBasketErrors["SYSTEM_LENGTH"] = "SYSTEM_LENGTH";
    EAllBasketErrors["EVENT_CANCELED"] = "EVENT_CANCELED";
    EAllBasketErrors["ERROR"] = "ERROR";
    EAllBasketErrors["EVENT_IS_OVER_DELETE"] = "EVENT_IS_OVER_DELETE";
    EAllBasketErrors["CHOOSE_YOUR_BET_LIVE_OR_IN_LINE"] = "CHOOSE_YOUR_BET_LIVE_OR_IN_LINE";
    EAllBasketErrors["CHANGED_COEFFICIENT"] = "CHANGED_COEFFICIENT";
    EAllBasketErrors["SUSPENDED"] = "SUSPENDED";
    EAllBasketErrors["MIN_AMOUNT_MUST_EXCEED"] = "MIN_AMOUNT_MUST_EXCEED";
    EAllBasketErrors["COUPON_NOT_AVAILABLE"] = "COUPON_NOT_AVAILABLE";
    EAllBasketErrors["COUPON_INSUFFICIENT_BETS_QUANTITY"] = "COUPON_INSUFFICIENT_BETS_QUANTITY";
    EAllBasketErrors["CLIENT_BETS_BLOCK"] = "CLIENT_BETS_BLOCK";
    EAllBasketErrors["BET_COMPETITOR_CONSTRAINT_ERROR"] = "BetCompetitorConstraintError";
})(EAllBasketErrors || (exports.EAllBasketErrors = EAllBasketErrors = {}));
exports.ALL_BASKET_ERROR_MESSAGES = {
    [betweb_openapi_axios_1.ErrorCode.BetsEventsMatched]: 'coupon dependent outcomes',
    [betweb_openapi_axios_1.ErrorCode.BetsHaveDependentEvents]: 'coupon dependent outcomes',
    [betweb_openapi_axios_1.ErrorCode.BetsOutcomesInequality]: 'bets outcomes inequality code',
    [betweb_openapi_axios_1.ErrorCode.BetsPayMaxExceeded]: 'exceeded maximum rate',
    [betweb_openapi_axios_1.ErrorCode.BetsSystemExpressLoweringBound]: 'bets system express lowering bound',
    [betweb_openapi_axios_1.ErrorCode.BetsAmountLessThanAllowed]: 'bets amount less than allowed',
    [betweb_openapi_axios_1.ErrorCode.BetsInsufficientBalance]: 'you do not have enough funds top up',
    [betweb_openapi_axios_1.ErrorCode.BetsInsufficientBonusBalance]: 'you do not have enough bonuses',
    [betweb_openapi_axios_1.ErrorCode.BetChangedCoefficient]: 'coefficient has been changed',
    [betweb_openapi_axios_1.ErrorCode.ClientBetsBlock]: 'there is a betting ban on your account',
    [betweb_openapi_axios_1.ErrorCode.CouponWrongMinOrdinarCoef]: 'coupon wrong min ordinar coef',
    [betweb_openapi_axios_1.ErrorCode.CouponWrongMaxOrdinarCoef]: 'coupon wrong max ordinar coef',
    [betweb_openapi_axios_1.ErrorCode.CouponWrongMinExpressCoef]: 'coupon wrong min express coef',
    [betweb_openapi_axios_1.ErrorCode.CouponWrongMaxExpressCoef]: 'coupon wrong max express coef',
    [betweb_openapi_axios_1.ErrorCode.CouponWrongMinCoefInsideExpress]: 'coupon wrong min coef inside express',
    [betweb_openapi_axios_1.ErrorCode.CouponWrongMaxCoefInsideExpress]: 'coupon wrong max coef inside express',
    [betweb_openapi_axios_1.ErrorCode.CouponNotAvailable]: 'coupon not available code',
    [betweb_openapi_axios_1.ErrorCode.CouponNotFound]: 'coupon not found',
    [betweb_openapi_axios_1.ErrorCode.CouponInsufficientBetsQuantity]: 'coupon insufficient bets quantity code',
    [betweb_openapi_axios_1.ErrorCode.BetChangedCoefMultiplier]: 'bet changed coef multiplier',
    [betweb_openapi_axios_1.ErrorCode.BetEventUndefined]: 'bet event undefined',
    [betweb_openapi_axios_1.ErrorCode.BetSuspended]: 'bet suspended',
    [EAllBasketErrors.MIN_AMOUNT_MUST_EXCEED]: 'amount must exceed min bet',
    [EAllBasketErrors.SUSPENDED]: 'acceptance has been suspended',
    [EAllBasketErrors.EXPRESS_LENGTH]: 'express hover text',
    [EAllBasketErrors.SYSTEM_LENGTH]: 'system hover text',
    [EAllBasketErrors.EVENT_CANCELED]: 'event canceled',
    [EAllBasketErrors.ERROR]: 'error',
    [EAllBasketErrors.EVENT_IS_OVER_DELETE]: 'event is over delete',
    [EAllBasketErrors.BETS_INSUFFICIENT_BONUS]: 'you do not have enough bonuses',
    [EAllBasketErrors.CHOOSE_YOUR_BET_LIVE_OR_IN_LINE]: 'choose your bet live or in line',
    [EAllBasketErrors.BET_COMPETITOR_CONSTRAINT_ERROR]: 'bets on some events unavailable',
};
exports.ERROR_LIST_WHEN_MAKE_RE_REQUEST_BASKET = [
    betweb_openapi_axios_1.ErrorCode.BetsOutcomesInequality,
    betweb_openapi_axios_1.ErrorCode.BetsHaveDependentEvents,
    betweb_openapi_axios_1.ErrorCode.BetsPayMaxExceeded,
];
exports.MOBILE_BOTTOM_ERRORS = [
    EAllBasketErrors.EXPRESS_LENGTH,
    EAllBasketErrors.SYSTEM_LENGTH,
    EAllBasketErrors.BETS_INSUFFICIENT_BALANCE,
    EAllBasketErrors.BETS_INSUFFICIENT_BONUS,
];
exports.WEB_BOTTOM_ERRORS = [
    EAllBasketErrors.BETS_INSUFFICIENT_BALANCE,
    EAllBasketErrors.BETS_INSUFFICIENT_BONUS,
];
exports.activeOutcomeStatus = [betweb_openapi_axios_1.EventProbabilitiesCategoryStatus.Trading];
exports.pendingOutcomeStatus = [betweb_openapi_axios_1.EventProbabilitiesCategoryStatus.Suspended];
exports.endedOutcomeStatus = [betweb_openapi_axios_1.EventProbabilitiesCategoryStatus.Unknown];
exports.activeEventStatus = [
    betweb_openapi_axios_1.EventStatus.Open,
    betweb_openapi_axios_1.EventStatus.Trading,
    betweb_openapi_axios_1.EventStatus.Planning,
];
exports.pendingEventStatus = [betweb_openapi_axios_1.EventStatus.Suspended];
exports.endedEventStatus = [
    betweb_openapi_axios_1.EventStatus.Ended,
    betweb_openapi_axios_1.EventStatus.Closed,
    betweb_openapi_axios_1.EventStatus.Retired,
    betweb_openapi_axios_1.EventStatus.Cancelled,
    betweb_openapi_axios_1.EventStatus.Postponed,
    betweb_openapi_axios_1.EventStatus.Interrupted,
];
exports.activeProbabilityStatus = [betweb_openapi_axios_1.EventProbabilityTradingStatus.Trading];
exports.pendingProbabilityStatus = [
    betweb_openapi_axios_1.EventProbabilityTradingStatus.Suspended,
];
exports.endedProbabilityStatus = [betweb_openapi_axios_1.EventProbabilityTradingStatus.Settled];
exports.DEFAULT_MAX_BET_EXPRESS_COEF = 2000;
exports.GET_BASKET_POLLING_INTERVAL = 5000;
exports.BASKET_STATUS_ERRORS = [401, 403];
//# sourceMappingURL=constants.js.map